import { CoreFileOptions, fileOpen, FirstFileOpenOptions } from 'browser-fs-access';
import { catchError, from, of, throwError } from 'rxjs';

export const isFileAbortError = (error: unknown): error is DOMException => {
  return error instanceof DOMException && error.name === 'AbortError';
};

export const showSaveFilePicker = <M extends boolean | undefined = false>(
  options?: [FirstFileOpenOptions<M>, ...CoreFileOptions[]] | FirstFileOpenOptions<M>
) => {
  return from(fileOpen<M>(options)).pipe(
    catchError((error) => {
      if (isFileAbortError(error)) {
        return of(undefined);
      }

      return throwError(() => error);
    })
  );
};
